var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 3.97266C13.0977 4.46484 12.3047 5.06641 9.51562 7.08984C8.96875 7.5 7.95703 8.40234 7 8.40234C6.01562 8.40234 5.03125 7.5 4.45703 7.08984C1.66797 5.06641 0.875 4.46484 0.246094 3.97266C0.136719 3.89062 0 3.97266 0 4.10938V9.6875C0 10.4258 0.574219 11 1.3125 11H12.6875C13.3984 11 14 10.4258 14 9.6875V4.10938C14 3.97266 13.8359 3.89062 13.7266 3.97266ZM7 7.5C7.62891 7.52734 8.53125 6.70703 8.99609 6.37891C12.6328 3.75391 12.9062 3.50781 13.7266 2.85156C13.8906 2.74219 14 2.55078 14 2.33203V1.8125C14 1.10156 13.3984 0.5 12.6875 0.5H1.3125C0.574219 0.5 0 1.10156 0 1.8125V2.33203C0 2.55078 0.0820312 2.74219 0.246094 2.85156C1.06641 3.50781 1.33984 3.75391 4.97656 6.37891C5.44141 6.70703 6.34375 7.52734 7 7.5Z",
    fill: "#025652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.786656db.svg";
export { ForwardRef as ReactComponent };